import type { TerraUIMessage } from '@terra/shared-dto-chat-types';
import {
  buildAskUserBranchResendMessage,
  createBranchMessageMetadata,
} from '@terra/ui-design-system';
import { historyPlacementMetadata } from './copilot-user-message-order';

type AskUserDataMessage = Parameters<
  typeof buildAskUserBranchResendMessage
>[0]['askUserDataMessage'];

export function metadataForOutgoingUserMessage({
  branchFromMessageId,
  isAnsweringAskUser,
  askUserResponseText,
  unansweredAskUser,
  liveMessages,
  status,
}: {
  branchFromMessageId?: string;
  isAnsweringAskUser: boolean;
  askUserResponseText: string;
  unansweredAskUser: AskUserDataMessage | null;
  liveMessages: readonly TerraUIMessage[];
  status: string;
}): TerraUIMessage['metadata'] | undefined {
  if (branchFromMessageId) {
    return createBranchMessageMetadata({ branchFromMessageId });
  }

  if (isAnsweringAskUser && unansweredAskUser) {
    return buildAskUserBranchResendMessage({
      selectedOption: {
        value: askUserResponseText,
        label: askUserResponseText,
      },
      askUserDataMessage: unansweredAskUser,
    }).metadata;
  }

  if (status === 'streaming' || status === 'submitted') {
    return historyPlacementMetadata({ liveMessages });
  }

  return undefined;
}
